import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Rule, RuleGroup } from "csi/middleware/attributeRule/RuleStore";
import CustomViewFilterGroup from "csi/view/customview/CustomViewFilterGroup";
import { CustomViewFilterGroupDragPreview } from "csi/view/customview/CustomViewFilterGroupDragPreview";
import CustomViewGroupingLevel from "csi/view/customview/CustomViewGroupingLevel";
import { GroupingLevel } from "csi/view/customview/CustomViewGroupingStore";
import CustomViewSingleFilterGrid from "csi/view/customview/CustomViewSingleFilterGrid";
import CustomViewSortingLevel from "csi/view/customview/CustomViewSortingLevel";
import { SortingLevel } from "csi/view/customview/CustomViewSortingStore";
import { IconButton } from "designSystem/index";
import React, { CSSProperties, ReactElement } from "react";

/** common drag preview styles, which alter incoming style */
const dragPreviewSx: CSSProperties = {
	visibility: "visible",
	width: 500,
	zIndex: 5,
};

/** common drop placeholder */
export const DropPlaceholderComponent = (
	<div
		style={{
			background: "var(--Grey100)",
			border: "1px solid var(--Grey300)",
			borderRadius: 3,
			height: 44,
			inset: "0px",
			marginLeft: 54,
			marginBottom: 8,
			marginTop: 8,
			pointerEvents: "none",
			zIndex: 4,
		}}
	/>
);

export const DropPlaceholderComponentForGroupingAndSortingPane = (
	<div
		style={{
			background: "var(--Grey100)",
			border: "1px solid var(--Grey300)",
			borderRadius: 3,
			height: 44,
			inset: "0px",
			marginBottom: 8,
			marginTop: 8,
			pointerEvents: "none",
			zIndex: 4,
		}}
	/>
);

/** common drag handle */
export const DragHandle = (
	<IconButton
		design="dragHandle"
		size="small"
	>
		<DragIndicatorIcon />
	</IconButton>
);

export const attributesSelectionGroupDropTypes = ["CUSTOM_VIEW_SELECTED_ATTRIBUTE", "CUSTOM_VIEW_SELECTED_GROUP"];

/** ------------- filter pane ---------- */

export const customViewFilterPaneDragHandleStyle: CSSProperties = {
	cursor: "grab",
	position: "absolute",
	top: 14,
	left: 58,
};

export const isFilterGroup = (ruleOrRuleGroup: RuleGroup | Rule): boolean => {
	return ruleOrRuleGroup instanceof RuleGroup;
};

export function customViewFilterPaneRenderListItem(ruleOrRuleGroup: RuleGroup | Rule): ReactElement {
	return (
		isFilterGroup(ruleOrRuleGroup) ? (
			<CustomViewFilterGroup ruleGroup={ruleOrRuleGroup as RuleGroup} />
		) : (
			<CustomViewSingleFilterGrid rule={ruleOrRuleGroup as Rule} />
		)
	);
}

export function customViewFilterPaneDragPreviewComponent(ruleOrRuleGroup: RuleGroup | Rule): ReactElement {
	return (
		<div style={dragPreviewSx}>
			{isFilterGroup(ruleOrRuleGroup) ? (
				<div style={{ position: "relative", left: 10, top: 32 }}>
					<CustomViewFilterGroupDragPreview ruleGroup={ruleOrRuleGroup as RuleGroup} />
				</div>
			) : (
				<CustomViewSingleFilterGrid isPreview rule={ruleOrRuleGroup as Rule} />
			)}
		</div>
	);
}

/** ------------- sorting / groupping pane -------------------------------------------- */
export const customViewSortingOrGroupingPaneDragHandleStyle: CSSProperties = { cursor: "grab", position: "absolute", top: 14, left: 4 };

/** ------------- grouping pane ---------- */

export function groupingPaneDragPreviewComponent(level: GroupingLevel): ReactElement {
	return (
		<div style={dragPreviewSx}>
			<CustomViewGroupingLevel level={level} />
		</div>
	);
}

export function groupingPaneRenderItem(level: GroupingLevel) {
	return <CustomViewGroupingLevel level={level} />;
}

/** ------------- sorting pane ---------- */

export function sortingPaneDragPreviewComponent(level: SortingLevel): ReactElement {
	return (
		<div style={dragPreviewSx}>
			<CustomViewSortingLevel level={level} />
		</div>
	);
}

export function sortingPaneRenderItem(level: SortingLevel): ReactElement {
	return (<CustomViewSortingLevel level={level} />);
}
